import moment from 'moment';
import { utcToZonedTime } from 'date-fns-tz';

function toLocalDateFormatter(value: any, format: any) {
    let theFormat: string =  'ddd, DD MMM YYYY';
    if (format) {
        theFormat = format;
    }
    if (value) {
        const timeZone = 'Australia/Sydney';
        const zonedDate = utcToZonedTime(value, timeZone);
        return moment(String(zonedDate)).format(theFormat);
    } else {
        return '';
    }
}

export default toLocalDateFormatter;
